import React, { useRef } from "react";
import {
  ERROR_TYPE,
  hasError,
  retryApiCall,
} from "../../../../../shared/util/services/data/DataService";
import { setErrorMessage } from "../../../../../shared/util/common/helper";
import PropTypes from "prop-types";
import { FundRequestDuplicatesTable } from "./DuplicateFundRequestsTable";
import { STAGE, STATUS } from "../../../../../shared/util/constants/fundRequestStatusType";
import { PROGRAM_TYPE } from "../../../../../shared/util/constants/programType";
import Link from "@amzn/awsui-components-react/polaris/link";
import useFeatureFlag from "shared/util/hooks/useFeatureFlag";
import { FEATURE_FLAG_ENUMS } from "shared/util/constants/featureFlagValues";

const FundRequestsDuplicatesSection = ({
  setNotificationsItems,
  stage,
  program,
  status
}) => {
  const Ref = useRef();

  const scrollToTable = () => {
    Ref.current = document.getElementById("duplicates_section");
    Ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const agiNonDupeCheckStage = [STAGE.CREATED, STAGE.PARTNER];
  const agiDuplicateFlag = useFeatureFlag(
    FEATURE_FLAG_ENUMS.AGI_DETERMINISTIC_DUPE_CHECKS_ENABLED
  );
  const agiDupeCheckStatus= [STATUS.ACTIVE, STATUS.EXPIRED, STATUS.COMPLETED];

  const duplicatePrograms = agiDuplicateFlag
    ? [
        PROGRAM_TYPE.SMP,
        PROGRAM_TYPE.MAP2024,
        PROGRAM_TYPE.POC,
        PROGRAM_TYPE.MISC,
        PROGRAM_TYPE.PIF,
      ]
    : [
        PROGRAM_TYPE.SMP,
        PROGRAM_TYPE.MAP2024,
        PROGRAM_TYPE.POC,
        PROGRAM_TYPE.MISC,
      ];
  const getDuplicateFundRequests = async ({
    getFundRequestDuplicates,
    setIsLoading,
  }) => {
    const data = [];
    try {
      const response = await retryApiCall({
        callApi: getFundRequestDuplicates({}),
      });
      console.log(response);
      if (hasError(response) && response.errorType === ERROR_TYPE.BANNER) {
        setErrorMessage({
          setNotificationsItems,
          content: response.message,
          status: response.status,
        });
        setIsLoading(false);
      }

      data.push(...response.duplicates);
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }

    if (data.length > 0) {
      setNotificationsItems([
        {
          type: "warning",
          content: (
            <React.Fragment>
              We identified possible duplicates with this fund request. Refer to
              the{" "}
              <Link onFollow={scrollToTable}>
                Fund Request Duplicates Table
              </Link>{" "}
              for additional details.
            </React.Fragment>
          ),
          dismissible: true,
          dimissLabel: "Dismiss message",
          onDismiss: () => setNotificationsItems([]),
          id: "duplicates_warning",
        },
      ]);
    }
    return data;
  };

  return duplicatePrograms.includes(program) &&
    !agiNonDupeCheckStage.includes(stage) &&
    agiDupeCheckStatus.includes(status)? (
    <div id={"duplicates_section"}>
      <FundRequestDuplicatesTable
        getDuplicateFundRequests={getDuplicateFundRequests}
        ref={Ref}
      />
    </div>
  ) : (
    <></>
  );
};

FundRequestsDuplicatesSection.propTypes = {
  setNotificationsItems: PropTypes.func,
  stage: PropTypes.string,
  program: PropTypes.string,
  status: PropTypes.string
};

export default FundRequestsDuplicatesSection;
